import { Component, OnInit } from '@angular/core';

import { ZeroService } from '../_services/zero/zero.service';
import { REST_SERVICES } from '../_services/settings';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { AuthenticationService } from '../_services/authentification.service';
import { first } from 'rxjs/operators';
import { FormBuilder,  FormGroup, Validators } from '@angular/forms';
import { CatalogoModel } from 'src/app/_models/bin-catalogos.model';
import { User, Role } from '../_models/oauth.models';

@Component({ templateUrl: './login.component.html',
             styleUrls: ['./login.component.css']})

export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    loading = true;
    submitted = false;
    error = '';
    public user : string = 'user';
    public rol : string = 'rol';
    public esquemas: Array<CatalogoModel>;
    public esquemaModel : CatalogoModel;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private cookieService: CookieService,
                private authenticationService: AuthenticationService,
                private zeroService: ZeroService,) {
                    this.authenticationService.changeScheme();                    
                    this.esquemas = new Array<CatalogoModel>();
                }

    ngOnInit() {
        console.log("DENTRO DE NGONINIT");
        this.loginForm = this.formBuilder.group({
            esquema: ['', Validators.required]
        });
        this.buscarEsquemas();
    }

     // convenience getter for easy access to form fields
     get f() { return this.loginForm.controls; }

     continuar(){
         if (this.f.esquema.value != '-1') {            
            this.loading = false;
         } else {             
            this.loading = true;
         }
     }

     buscarEsquemas(){
        let scope = this;
        scope.zeroService.request({
          isSingleResponse: false,
          uri: REST_SERVICES.CATALOGO_ESQUEMAS,
          method: "GET",
          swhowInfo: true,
          ok: (response) => {
              scope.esquemas = response.response;
          }
        });
    }

    onSubmit() {
        console.log("DENTRO DE ONSUBMIT");
        var esquema_id = this.f.esquema.value;
        this.esquemaModel = this.esquemas.find(x => x.id == esquema_id);
        var esquema_dsc = this.esquemaModel.descripcion;
        this.submitted = true;

        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }

        let valCookie = this.cookieService.get(environment.app);                
               
        if (!valCookie) {
            // validar sesion
            window.location.href = environment.uris.comunes.login;
        }
        
        let segementos: string[] = valCookie.split("-");
        if (segementos && segementos.length == 3) {
            let user = segementos[2];
            let rol = segementos[0];

            this.loading = true;
            this.authenticationService.login(user, rol, esquema_dsc, esquema_id)
                .pipe(first())
                .subscribe(
                    data => {
                        let returnUrl = this.authenticationService.redirectForRol;
                        this.router.navigate([ returnUrl ], {
                            queryParams: { refresh: new Date().getTime() }
                        });
                    },
                    error => {
                        this.error = error;
                        this.loading = false;
            });
        }

    }
}
